import React from 'react';
import PropTypes from 'prop-types';
import Puff from './Puff';

export default class DiscoverKingdom extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object
    };
    render() {
        const {
            title, description, title1, title2
        } = this.props.content;
        return (
            <div className="discover-kingdom">
                <div className="background" />
                <div className="content">
                    <h1>{title1 && title2 ? <>{title1}<br></br>{title2}</> : title}</h1>
                    <div dangerouslySetInnerHTML={{__html: description}} />
                </div>
                <Puff />
            </div>
        );
    }
}

